module.exports = __webpack_public_path__ + "static/media/Banner.bc022149.png";